var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacKfw40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "167px",
    height: "247px",
    viewBox: "-0.5 -0.5 167 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 3 125",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 3.98 204.9 2.24 167.4 3 125 M 3 243 C 3.94 218.08 2.52 193.42 3 125",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 103 M 3 103 C 29.02 69.23 56.31 37.83 83 3 M 3 103 C 25.54 75.52 48.25 46.66 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 L 163 243",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 243 M 3 243 C 55.05 241.7 107.38 243.27 163 243 M 3 243 C 58.91 243.6 115.26 244.15 163 243",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 L 163 123",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 243 M 163 243 C 162.32 205.13 165.05 163.58 163 123 M 163 243 C 163.04 216.38 162.35 189.04 163 123",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 L 83 3",
    fill: "none",
    stroke: "none",
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 163 103 M 163 103 C 138.66 70.86 109.99 36.06 83 3 M 163 103 C 138.34 74.71 115.4 43.91 83 3",
    fill: "none",
    stroke: "#666666",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 153,
    width: 147,
    height: 83,
    fill: "#004c3f",
    stroke: "#004c3f",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacKfw40);
export default __webpack_public_path__ + "static/media/fac_kfw40.555ae817cd95251ef7978e8be964f375.svg";
export { ForwardRef as ReactComponent };